module.exports = __webpack_public_path__ + "static/media/patient-secure-file-icon_2-color.de3f8085.svg";